/**
 * A record of catalogue texts that translates on every read, in the cabinet's language of that
 * moment (design 29, W5). For the tables other modules read while they render - the period names,
 * the support page's words - which are built once, at load, and so must never hold a text
 * translated then.
 */
export function liveTexts<K extends string>(
  keys: readonly K[],
  translate: (key: K) => string,
): Readonly<Record<K, string>> {
  const texts = {} as Record<K, string>;
  for (const key of keys) {
    Object.defineProperty(texts, key, { enumerable: true, get: () => translate(key) });
  }
  return Object.freeze(texts);
}
